import { useQuery } from 'react-query';
import { CashRegisterOperationsService } from '../../services';
import { ICashRegisterOperationWithSub } from '../../interfaces';

export const useCashRegisterOperationsWithSub = () => {
  return useQuery<ICashRegisterOperationWithSub[], Error>(
    ['cash-register-operations', 'with-sub'],
    async () => {
      const result = await CashRegisterOperationsService.getListWithSub();
      if (result.status === 200) return result.data.data;
      throw new Error(result.data as string);
    },
    { staleTime: 5 * 60 * 1000 },
  );
};
